import { Dropdown, TextArea } from 'framework/form';
import { useIsMyProfile } from 'domain/shared/employee';
import ExpertiseInput from '../../fields/ExpertiseInput';
import {
  ExpertiseExperienceDurationLabels,
  ExpertiseExperienceTypeLabels,
  ExpertiseLevelLabels,
} from 'domain/people/employee/expertise/service/expertiseService.model';

interface Props {
  isEdit?: boolean;
}

const AddExpertiseForm = ({ isEdit }: Props) => {
  const isEmployeePortal = useIsMyProfile();
  const getDropDownField = ({
    source,
    label: fieldLabel,
    enumOptions,
  }: {
    source: string;
    label: string;
    enumOptions: Dictionary<string>;
  }) => (
    <Dropdown
      source={source}
      isRequired
      placeholder={`Choose ${fieldLabel}`}
      options={Object.entries(enumOptions).map(entry => {
        const [value, label] = entry;
        return {
          value,
          label,
        };
      })}
      label={fieldLabel}
    />
  );

  return (
    <>
      {!isEdit && (
        <ExpertiseInput
          isRequired
          placeholder={`Expertise`}
          source="expertiseId"
          errorSource="expertise"
          label="Expertise"
        />
      )}
      {getDropDownField({ source: 'level', label: 'Level', enumOptions: ExpertiseLevelLabels })}
      {getDropDownField({
        source: 'expertiseType',
        label: 'Experience',
        enumOptions: ExpertiseExperienceTypeLabels,
      })}
      {getDropDownField({
        source: 'experienceDuration',
        label: 'Experience duration',
        enumOptions: ExpertiseExperienceDurationLabels,
      })}
      {!isEmployeePortal && <TextArea source="comment" label="Comment" />}
    </>
  );
};

export default AddExpertiseForm;
